import Vue from 'vue'

// 全局注册vant组件（按需引入）
import {
  NavBar,
  Form,
  Field,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Swipe,
  SwipeItem,
  Lazyload,
  Grid,
  GridItem,
  Image,
  Divider,
  Calendar,
  Picker,
  Popup,
  Cell,
  CellGroup,
  Cascader,
  Card,
  Tab,
  Tabs,
  Tag,
  Dialog,
  DatetimePicker,
  Col,
  Row,
  List,
  NoticeBar,
  Empty,
  SwipeCell,
  PullRefresh,
  Uploader,
  Loading,
  Collapse,
  CollapseItem,
  Pagination
} from 'vant'
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Image)
Vue.use(Divider)
Vue.use(Calendar)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Cascader)
Vue.use(Card)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Dialog)
Vue.use(DatetimePicker)
Vue.use(Col)
Vue.use(Row)
Vue.use(List)
Vue.use(NoticeBar)
Vue.use(Empty)
Vue.use(SwipeCell)
Vue.use(PullRefresh)
Vue.use(Uploader)
Vue.use(Loading)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Pagination)
